import type { ReactNode } from 'react';

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@shigo-ui/ui';

import { DashboardTableFilterTrigger } from './DashboardTableFilterTrigger';

export interface DashboardTableMultiSelectFilterOption<TValue extends string> {
  value: TValue;
  label: ReactNode;
  count?: number | undefined;
}

export function DashboardTableMultiSelectFilter<TValue extends string>({
  value,
  options,
  label,
  ariaLabel,
  onChange,
}: {
  value: readonly TValue[];
  options: readonly DashboardTableMultiSelectFilterOption<TValue>[];
  label: ReactNode;
  ariaLabel: string;
  onChange: (value: TValue[]) => void;
}) {
  const selected = new Set(value);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <DashboardTableFilterTrigger label={label} aria-label={ariaLabel} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        {options.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.value}
            checked={selected.has(option.value)}
            onSelect={(event) => {
              event.preventDefault();
            }}
            onCheckedChange={(checked) => {
              onChange(
                checked
                  ? [...new Set([...value, option.value])]
                  : value.filter((item) => item !== option.value),
              );
            }}
          >
            <span className="flex min-w-0 flex-1 justify-between gap-3">
              <span className="truncate">{option.label}</span>
              {option.count === undefined ? null : (
                <span className="text-muted-foreground shrink-0">{option.count}</span>
              )}
            </span>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
